import { useMemo } from 'react'
import microApp from '@micro-zoe/micro-app'

const _window = window as any

/**
 * 判断权限
 * @param code
 * @returns
 */
export const usePermission = (code: string) => {
  const auth = useMemo(() => {
    let globalData = null
    if (_window.__MICRO_APP_BASE_APPLICATION__) {
      // 主应用获取全局数据
      globalData = microApp.getGlobalData() // 返回全局数据
    } else {
      // 子应用获取全局数据
      globalData = _window.microApp.getGlobalData() // 返回全局数据
    }

    const { permissions = [] } = globalData || {}

    if (!code) {
      return false
    }

    const [navCode, permissionCode] = code.split(':')

    const permission = permissions.find((p: any) => p.navCode === navCode && p.permissionCode === permissionCode)
    if (permission) {
      return true
    }

    return false
  }, [code])

  return auth
}
